export const DomainConstant = {
    DOMAIN_CODE_ORDER: "ORDER",
    DOMAIN_CODE_TRANSPORT: "TRANSPORT",
    DOMAIN_CODE_PRODUCT: "PRODUCT",
    DOMAIN_CODE_USER: "USER",
    DOMAIN_CODE_PRICERULE: "PRICERULE",
    DOMAIN_CODE_PRICE: "PRICE",
    DOMAIN_CODE_INSIGHT: "INSIGHT",
}